<template src='./index.html'></template>
<script>
import { getdata } from './data.js';
import ywlxgltj from './ywlxgltj/index.vue'
import xjgz from '@/components/common/ywlxgz/ywgz/xjgz/index.vue';
import { ywlxgl_query, ywlxgz_scgz } from '@/api/ywlxgz';
import { comMapping } from '@/components/util/Function/comMapping';

export default {
    name: 'ywlxzt_ywgz_ywlxgl',
    components: {
        xjgz,
        ywlxgltj // 业务类型管理添加弹框
    },
    props: {
        ywlxgldialog: {
            type: Boolean,
            default: false
        },
        ywzx:{
            type: String,
            default: "0"
        }
    },
    watch: {
        ywlxgldialog:function(indexVal, oldVal) {
            if (indexVal) {
                this.$nextTick(() => {
                    this.loadBusinessData();
                });
            }
        },
    },
    data: function() {
        return {
            tablekey: 0,
            overlength: 0,
            headData: getdata().headData,
            tableData: [],
            pagination: getdata().pagination,
            ywlxgltjdialog: false,
            ywzl: comMapping.$ywzx,
            qzfw: comMapping.$qzfw,
            sjlx: comMapping.$sjlx,
            formData: {}
        };
    },
    mounted() {
    },
    created() {

    },
    methods: {
        loadBusinessData() {
            let params = {};
            params.current = this.pagination.pageNum;
            params.size = this.pagination.pageSize;
            params.sort = '';
            params.order = '';
            ywlxgl_query(params).then(res => {
                if (res.data.code !== "1") {
                    this.$message.error(res.data.msg);
                } else {
                    this.pagination.total = res.data.data.total;
                    this.tableData = res.data.data.records;
                }
            });
        },
        closediag() {
            this.$emit('closediag', false);
        },
        sizechange(e) {
            this.pagination.pageSize = e;
            this.loadBusinessData();
        },
        currentChange(e) {
            this.pagination.pageNum = e;
            this.loadBusinessData();
        },
        submitSearch() {
            this.pagination.pageNum = 1;
            this.pagination.paginationkey++;
            this.loadBusinessData();
        },
        forRefresh() {
            this.pagination.pageNum = 1;
            this.pagination.paginationkey++;
        },
        forUpdateSearch() {
            this.filterSearchlist = JSON.parse(JSON.stringify(this.filterSearchlist.length ? this.filterSearchlist : this.searchlist));
            this.searchdiag = true;
        },
        addBusiness() {
            // 添加按钮点击
            this.ywlxgltjdialog = true;
            this.formData = {}
        },
        ywlxgltjclosediag() {
            this.ywlxgltjdialog = false;
            this.loadBusinessData();
        },
        businessEdit(e) {
            // 编辑按钮
            this.ywlxgltjdialog = true
            this.formData = e
        },
        businessDelete(e) {
            // 删除按钮
            this.$showConfirm({
                message: "确认删除【"+e.bsName+"】该规则吗？",
            }).then((result) => {
                if (result === "confirm") {
                    let params = {id: e.id, code: e.code};
                    ywlxgz_scgz(params).then(res => {
                        if (res.data.code !== "1") {
                            this.$message.error(res.data.msg);
                        } else {
                            this.$message.success(res.data.msg);
                            this.loadBusinessData();
                        }
                    })
                }
            })
        }
    }
};
</script>

<style scoped lang='less'>
@import url('./index.less');
</style>
